import axios, { AxiosRequestConfig } from "axios";
import { getEnvVariable, REACT_APP_API_URL } from "utils/environment";
import { retrieveTokenFromLocalStorage } from "services/utils/serviceutils";
import {
    AppsContainerModel,
    AppsContainerItem,
    AppsContainerGroup,
} from "types/apps-container";

export const getAllApplicationContainers = (onlyVisible: boolean = true) => {
    const url = `${getEnvVariable(
        REACT_APP_API_URL
    )}container/?visible=${onlyVisible}`;
    const config: any = {
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const updateApplicationContainer = (data: AppsContainerGroup) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}container/`;
    const config: AxiosRequestConfig = {
        method: "put",
        data,
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const deleteApplicationContainer = (containerID: number) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}container/${containerID}`;
    const config: AxiosRequestConfig = {
        method: "DELETE",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const updateApplicationContainerVisibility = (containerID: number) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}container/${containerID}`;
    const config: AxiosRequestConfig = {
        method: "PATCH",
        url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const getAllApplicationContainersGrouped = () => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}container/grouped`;
    const config: any = {
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const updateApplicationContainersGrouped = (
    data: AppsContainerModel
) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}container/grouped`;
    const config: AxiosRequestConfig = {
        method: "put",
        data,
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const updateApplicationContainerItem = (data: AppsContainerItem) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}containerItem/`;
    const config: AxiosRequestConfig = {
        method: "put",
        data,
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const createApplicationContainerItem = (data: AppsContainerItem) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}containerItem/`;
    const config: AxiosRequestConfig = {
        method: "post",
        data,
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const deleteApplicationContainerItem = (id: number) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}containerItem/${id}`;
    const config: AxiosRequestConfig = {
        method: "delete",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};
